// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-2Ues1qRz fl","tabSwitch":"tabSwitch-1xeF6Vu6"};